import api from '../api'

export default {
    namespaced: true,

    actions: {
        getintegralUserList(store,params) {
            return api.post(`/data/statistics/userOneIntegral`, '普通用户的输赢积分', params)
        },
        getintegralRoomList(store,params) {
            return api.post(`/data/statistics/roomIntegral`, '用户房间列表输赢积分', params)
        },
        getintegralUserOne(store,params){
            return api.post(`/data/statistics/userOneIntegral`, '用户详情列表输赢积分', params)
        },
        getintegralTribeList(store, params){
            return api.post(`/data/statistics/tribeIntegral`, '联盟列表输赢积分', params)
        },
        getintegralClubList(store, params){
            return api.post(`/data/statistics/clubIntegral`, '俱乐部列表输赢积分', params)
        }

    }
}